import { ArtizenUserClass, TEfactureArtisan, TEfactureArtisanSave } from '@Arti-zen/package-backoffice'
import { Api } from '@mui/icons-material'
import { Button, Dialog, Menu } from '@mui/material'
import { useAppSelector } from 'hooks/useStore'
import { ArtisanWithEfacture } from 'modules/eInvoicing/components/EinvoicingArtisansCtrl/EinvoicingArtisansCtrl'
import { FacturXReadyTestResultColor } from 'modules/eInvoicing/components/EinvoicingArtisansCtrl/EinvoicingArtisansCtrl.definitionFields'
import InterestLevelContent, {
  interestLevelColors,
} from 'modules/eInvoicing/components/EinvoicingArtisansCtrl/InterestLevelContent'
import IsFacturXReadyContent from 'modules/eInvoicing/components/EinvoicingArtisansCtrl/IsFacturXReadyContent'
import { ReactElement, useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'
import { ApiArtizenBO } from 'utils/artizenConnector'

export default function ArtisanEfacture(): ReactElement {
  const { artisan, isLoading } = useAppSelector((state) => state.artisan)
  const [artisanEFact, setArtisanEFact] = useState<ArtizenUserClass>(null)
  const [efactureArtisan, setEfactureArtisan] = useState<TEfactureArtisan>(null)
  const [dialogContent, setDialogContent] = useState<ReactElement | null>(null)

  useEffect(() => {
    if (artisan?.id) {
      ApiArtizenBO.efactureArtisan.getByCompany(artisan.id).then(setEfactureArtisan).catch(console.error)
      ApiArtizenBO.artizenUsers.getCompany(artisan.id).then(setArtisanEFact).catch(console.error)
    }
  }, [artisan?.id])

  const updateEfactureArtisan = async (companyId: TEfactureArtisan['companyId'], changes: TEfactureArtisanSave) => {
    await ApiArtizenBO.efactureArtisan.putByCompany({ companyId, changes }).catch(console.error)
    await ApiArtizenBO.efactureArtisan.getByCompany(companyId).then(setEfactureArtisan).catch(console.error)
  }

  const artisanFull: ArtisanWithEfacture = useMemo(() => {
    return new ArtisanWithEfacture(artisanEFact, efactureArtisan)
  }, [artisanEFact, efactureArtisan])

  console.log('artisanFull', artisanFull)

  return !isLoading && artisan ? (
    <Wrapper>
      <MenuWrapper>
        <h1>Informations E-facture</h1>
        <AnimationItem>
          <div>Factur-X :</div>
          <Button
            variant="contained"
            size="small"
            onClick={(e) => {
              e.stopPropagation() // évite le onClick de la ligne
              setDialogContent(<IsFacturXReadyContent artisan={artisanFull} />)
            }}
            sx={{
              textTransform: 'none',
              fontWeight: 'bold',
              backgroundColor: FacturXReadyTestResultColor[artisanFull?.isFacturXReady?.state],
              '&:hover': {
                backgroundColor: FacturXReadyTestResultColor[artisanFull?.isFacturXReady?.state],
                opacity: 0.9,
              },
            }}
          >
            {artisanFull?.isFacturXReady?.state}
          </Button>
        </AnimationItem>
      </MenuWrapper>

      <h2>Animation </h2>
      <AnimationItem>
        <div>Intérêt :</div>
        <Button
          variant="contained"
          size="small"
          onClick={(e) => {
            e.stopPropagation()
            setDialogContent(
              <InterestLevelContent
                artisan={artisanFull}
                updateEfactureArtisanList={updateEfactureArtisan}
                close={() => setDialogContent(null)}
              />
            )
          }}
          sx={{
            textTransform: 'none',
            fontWeight: 'bold',
            minWidth: 120,
            backgroundColor: interestLevelColors[artisanFull?.interestLevel] ?? '#000000',
            '&:hover': {
              backgroundColor: interestLevelColors[artisanFull?.interestLevel] ?? '#000000',
              opacity: 0.5,
            },
          }}
        >
          {artisanFull?.interestLevel ? artisanFull?.interestLevel : 'Non contacté'}
        </Button>
      </AnimationItem>
      <AnimationItem>
        <div>Raison :</div>
        <div>{artisanFull?.efactureArtisan?.reason}</div>
      </AnimationItem>
      <AnimationItem>
        <div>Commentaire :</div>
        <div>{artisanFull?.efactureArtisan?.comment}</div>
      </AnimationItem>
      <Dialog open={!!dialogContent} onClose={() => setDialogContent(null)} fullScreen={false}>
        {dialogContent || 'Erreur inconnue'}
      </Dialog>
    </Wrapper>
  ) : null
}

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: left;
  align-items: left;
`

const MenuWrapper = styled.div`
  display: flex;
  flex-direction: column;
  h1,h2 {
    margin-bottom: 20px;
  }
  gap: 5px;
  margin-bottom: 20px;
`

const AnimationItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  margin-bottom: 10px;

  > div:first-child {
    width: 200px;
    flex-shrink: 0;
    padding-left: 10px;
    font-weight: bold;
    font-style: italic;
  }
`
